import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-593de9b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("打印/详情")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("打印")
const _hoisted_6 = { id: "printBox" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { align: "center" }, "应  聘  登  记  表", -1))
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { style: {"float":"right"} }
const _hoisted_10 = {
  align: "center",
  border: "1",
  width: "95%",
  height: "700",
  cellspacing: "0"
}
const _hoisted_11 = {
  align: "center",
  height: "40"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "姓名", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "性别", -1))
const _hoisted_14 = { colspan: "2" }
const _hoisted_15 = {
  align: "center",
  height: "40"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "出生年月", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "籍贯", -1))
const _hoisted_18 = { colspan: "2" }
const _hoisted_19 = {
  align: "center",
  height: "40"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "身份证号", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "民族", -1))
const _hoisted_22 = { colspan: "2" }
const _hoisted_23 = {
  align: "center",
  height: "40"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "健康状态", -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "政治面貌", -1))
const _hoisted_29 = {
  key: 3,
  colspan: "2"
}
const _hoisted_30 = {
  key: 4,
  colspan: "2"
}
const _hoisted_31 = {
  key: 5,
  colspan: "2"
}
const _hoisted_32 = {
  align: "center",
  height: "40"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "联系电话", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "毕业院校", -1))
const _hoisted_35 = { colspan: "2" }
const _hoisted_36 = {
  height: "40",
  align: "center"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "专业", -1))
const _hoisted_38 = { align: "center" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "婚姻状况", -1))
const _hoisted_40 = {
  key: 0,
  colspan: "2"
}
const _hoisted_41 = {
  key: 1,
  colspan: "2"
}
const _hoisted_42 = {
  key: 2,
  colspan: "2"
}
const _hoisted_43 = {
  height: "40",
  align: "center"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "职称", -1))
const _hoisted_45 = { align: "center" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "学历", -1))
const _hoisted_47 = {
  key: 0,
  colspan: "2"
}
const _hoisted_48 = {
  key: 1,
  colspan: "2"
}
const _hoisted_49 = {
  key: 2,
  colspan: "2"
}
const _hoisted_50 = {
  key: 3,
  colspan: "2"
}
const _hoisted_51 = {
  key: 4,
  colspan: "2"
}
const _hoisted_52 = {
  key: 5,
  colspan: "2"
}
const _hoisted_53 = {
  key: 6,
  colspan: "2"
}
const _hoisted_54 = {
  key: 7,
  colspan: "2"
}
const _hoisted_55 = {
  height: "40",
  align: "center"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "微机操作", -1))
const _hoisted_57 = { align: "center" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "紧急联系人及电话", -1))
const _hoisted_59 = {
  colspan: "2",
  align: "center"
}
const _hoisted_60 = {
  align: "center",
  height: "40"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "应聘职位", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "期望薪资", -1))
const _hoisted_63 = {
  align: "center",
  colspan: "2"
}
const _hoisted_64 = {
  height: "40",
  align: "center"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "家庭住址", -1))
const _hoisted_66 = {
  align: "center",
  colspan: "4"
}
const _hoisted_67 = {
  height: "40",
  align: "center"
}
const _hoisted_68 = ["rowspan"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "起止时间", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "教育经历/工作经历", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "职位", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "证明人", -1))
const _hoisted_73 = {
  height: "40",
  align: "center"
}
const _hoisted_74 = ["rowspan"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "姓名", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "关系", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "工作地", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "职务", -1))
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { key: 2 }
const _hoisted_82 = { key: 3 }
const _hoisted_83 = { key: 4 }
const _hoisted_84 = { key: 5 }
const _hoisted_85 = { key: 6 }
const _hoisted_86 = { key: 7 }
const _hoisted_87 = { key: 8 }
const _hoisted_88 = {
  height: "40",
  align: "center"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { height: "50" }, "个人爱好/特长", -1))
const _hoisted_90 = { colspan: "4" }
const _hoisted_91 = {
  height: "40",
  align: "center"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { height: "50" }, "自我能力评估", -1))
const _hoisted_93 = { colspan: "4" }
const _hoisted_94 = {
  height: "40",
  align: "center"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { height: "50" }, "其他要求", -1))
const _hoisted_96 = { colspan: "4" }
const _hoisted_97 = { height: "40" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  height: "50",
  align: "center",
  style: {"text-align":"center"}
}, "测试情况", -1))
const _hoisted_99 = { colspan: "4" }
const _hoisted_100 = { style: {"font-weight":"bold"} }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { key: 1 }
const _hoisted_103 = { key: 2 }
const _hoisted_104 = { key: 3 }
const _hoisted_105 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_print = _resolveDirective("print")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, { title: "应聘登记" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          autocomplete: "off",
          layout: "inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "姓名" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "姓名",
                  value: _ctx.searches.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.name) = $event)),
                  "allow-clear": ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "面试时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: _ctx.searches.create_time,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.create_time) = $event)),
                  valueFormat: "YYYY-MM-DD"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.onSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { onClick: _ctx.onReset }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: _ctx.columns,
          loading: _ctx.loading,
          bordered: "",
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'gender')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(record.gender == 0 ? '保密' : record.gender === 1 ? '男' : '女'), 1))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  type: "primary",
                  onClick: ($event: any) => (_ctx.getDetail(record)),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: "应聘登记表",
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
          key: "submit",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })), [
          [_directive_print, _ctx.print]
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(" 应聘岗位：" + _toDisplayString(_ctx.detailData.position) + " ", 1),
            _createElementVNode("div", _hoisted_9, "填表时间：" + _toDisplayString(_ctx.detailData.create_time), 1)
          ]),
          _createElementVNode("table", _hoisted_10, [
            _createElementVNode("tr", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("td", null, _toDisplayString(_ctx.detailData.name), 1),
              _hoisted_13,
              _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.detailData.gender == 0 ? '保密' : _ctx.detailData.gender == 1 ? '男' : '女'), 1)
            ]),
            _createElementVNode("tr", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("td", null, _toDisplayString(_ctx.detailData.birthday), 1),
              _hoisted_17,
              _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.detailData.ancestral_home), 1)
            ]),
            _createElementVNode("tr", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("td", null, _toDisplayString(_ctx.detailData.id_number), 1),
              _hoisted_21,
              _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.detailData.ethnic_group), 1)
            ]),
            _createElementVNode("tr", _hoisted_23, [
              _hoisted_24,
              (_ctx.detailData.health_status == 1)
                ? (_openBlock(), _createElementBlock("td", _hoisted_25, "健康"))
                : _createCommentVNode("", true),
              (_ctx.detailData.health_status == 2)
                ? (_openBlock(), _createElementBlock("td", _hoisted_26, "亚健康"))
                : _createCommentVNode("", true),
              (_ctx.detailData.health_status == 3)
                ? (_openBlock(), _createElementBlock("td", _hoisted_27, "其他"))
                : _createCommentVNode("", true),
              _hoisted_28,
              (_ctx.detailData.political_landscape == 0)
                ? (_openBlock(), _createElementBlock("td", _hoisted_29, "群众"))
                : _createCommentVNode("", true),
              (_ctx.detailData.political_landscape == 1)
                ? (_openBlock(), _createElementBlock("td", _hoisted_30, "团员"))
                : _createCommentVNode("", true),
              (_ctx.detailData.political_landscape == 2)
                ? (_openBlock(), _createElementBlock("td", _hoisted_31, "党员"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("td", null, _toDisplayString(_ctx.detailData.phone), 1),
              _hoisted_34,
              _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.detailData.graduate_school), 1)
            ]),
            _createElementVNode("tr", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.detailData.major), 1),
              _hoisted_39,
              (_ctx.detailData.marital_status == 0)
                ? (_openBlock(), _createElementBlock("td", _hoisted_40, "未婚"))
                : _createCommentVNode("", true),
              (_ctx.detailData.marital_status == 1)
                ? (_openBlock(), _createElementBlock("td", _hoisted_41, "已婚"))
                : _createCommentVNode("", true),
              (_ctx.detailData.marital_status == 2)
                ? (_openBlock(), _createElementBlock("td", _hoisted_42, "离异"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.detailData.job_title), 1),
              _hoisted_46,
              (_ctx.detailData.degree == 1)
                ? (_openBlock(), _createElementBlock("td", _hoisted_47, "初中及以下"))
                : _createCommentVNode("", true),
              (_ctx.detailData.degree == 2)
                ? (_openBlock(), _createElementBlock("td", _hoisted_48, "高中"))
                : _createCommentVNode("", true),
              (_ctx.detailData.degree == 3)
                ? (_openBlock(), _createElementBlock("td", _hoisted_49, "中专/中技"))
                : _createCommentVNode("", true),
              (_ctx.detailData.degree == 4)
                ? (_openBlock(), _createElementBlock("td", _hoisted_50, "大专"))
                : _createCommentVNode("", true),
              (_ctx.detailData.degree == 5)
                ? (_openBlock(), _createElementBlock("td", _hoisted_51, "本科"))
                : _createCommentVNode("", true),
              (_ctx.detailData.degree == 6)
                ? (_openBlock(), _createElementBlock("td", _hoisted_52, "硕士 "))
                : _createCommentVNode("", true),
              (_ctx.detailData.degree == 7)
                ? (_openBlock(), _createElementBlock("td", _hoisted_53, "MBA/EMB"))
                : _createCommentVNode("", true),
              (_ctx.detailData.degree == 8)
                ? (_openBlock(), _createElementBlock("td", _hoisted_54, "博士"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.detailData.microcomputer_operation), 1),
              _hoisted_58,
              _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.detailData.emergency_contact), 1)
            ]),
            _createElementVNode("tr", _hoisted_60, [
              _hoisted_61,
              _createElementVNode("td", null, _toDisplayString(_ctx.detailData.position), 1),
              _hoisted_62,
              _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.detailData.salary), 1)
            ]),
            _createElementVNode("tr", _hoisted_64, [
              _hoisted_65,
              _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.detailData.home_address), 1)
            ]),
            _createElementVNode("tr", _hoisted_67, [
              _createElementVNode("th", {
                align: "center",
                rowspan: _ctx.detailData.experience.length + 1
              }, "个人经历", 8, _hoisted_68),
              _hoisted_69,
              _hoisted_70,
              _hoisted_71,
              _hoisted_72
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.experience, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                align: "center",
                height: "40",
                key: item.id || item.date_start_end
              }, [
                _createElementVNode("td", null, _toDisplayString(item.date_start_end), 1),
                _createElementVNode("td", null, _toDisplayString(item.experience), 1),
                _createElementVNode("td", null, _toDisplayString(item.job_title), 1),
                _createElementVNode("td", null, _toDisplayString(item.contact) + "（" + _toDisplayString(item.contact_phone) + "）", 1)
              ]))
            }), 128)),
            _createElementVNode("tr", _hoisted_73, [
              _createElementVNode("th", {
                align: "center",
                rowspan: _ctx.detailData.family_members.length + 1
              }, "家庭主要成员", 8, _hoisted_74),
              _hoisted_75,
              _hoisted_76,
              _hoisted_77,
              _hoisted_78
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.family_members, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                align: "center",
                height: "40",
                key: item.id || item.name
              }, [
                _createElementVNode("td", null, _toDisplayString(item.name), 1),
                (item.relationship == 1)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_79, "父子 "))
                  : _createCommentVNode("", true),
                (item.relationship == 2)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_80, "母子 "))
                  : _createCommentVNode("", true),
                (item.relationship == 3)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_81, "父女"))
                  : _createCommentVNode("", true),
                (item.relationship == 4)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_82, "母女 "))
                  : _createCommentVNode("", true),
                (item.relationship == 5)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_83, "兄弟 "))
                  : _createCommentVNode("", true),
                (item.relationship == 6)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_84, "兄妹"))
                  : _createCommentVNode("", true),
                (item.relationship == 7)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_85, "姐弟"))
                  : _createCommentVNode("", true),
                (item.relationship == 8)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_86, "姐妹"))
                  : _createCommentVNode("", true),
                (item.relationship == 9)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_87, "夫妻"))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, _toDisplayString(item.workplace), 1),
                _createElementVNode("td", null, _toDisplayString(item.job_title), 1)
              ]))
            }), 128)),
            _createElementVNode("tr", _hoisted_88, [
              _hoisted_89,
              _createElementVNode("td", _hoisted_90, _toDisplayString(_ctx.detailData.hobbies), 1)
            ]),
            _createElementVNode("tr", _hoisted_91, [
              _hoisted_92,
              _createElementVNode("td", _hoisted_93, _toDisplayString(_ctx.detailData.competency_assessment), 1)
            ]),
            _createElementVNode("tr", _hoisted_94, [
              _hoisted_95,
              _createElementVNode("td", _hoisted_96, _toDisplayString(_ctx.detailData.other_requirement), 1)
            ]),
            _createElementVNode("tr", _hoisted_97, [
              _hoisted_98,
              _createElementVNode("td", _hoisted_99, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.qa, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id || index,
                    style: {"margin":"20px"}
                  }, [
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("span", null, _toDisplayString(index + 1) + "、", 1),
                      (item.type == 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_101, "（单选题）"))
                        : _createCommentVNode("", true),
                      (item.type == 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_102, "（判断题）"))
                        : _createCommentVNode("", true),
                      (item.type == 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_103, "（多选题）"))
                        : _createCommentVNode("", true),
                      (item.type == 4)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_104, "（填空题）"))
                        : _createCommentVNode("", true),
                      (item.type == 5)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_105, "（任选题）"))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(item.title) + "（" + _toDisplayString(item.score) + "分）", 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.questionOptions, (item2, index2) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item2.id || index2
                      }, _toDisplayString(item2.index) + "、" + _toDisplayString(item2.value), 1))
                    }), 128)),
                    _createElementVNode("div", null, "答案：" + _toDisplayString(item.answer), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}